import { UrlUtils } from "Global/Base/Utils/UrlUtils";
import { IAppAddresses } from "./IAppAddresses";

/**
 * Třída s informacemi o adresách běžící aplikace
 * @internal
 */
export class ApplicationInfo implements IAppAddresses {
    private readonly _appId: string;

    private readonly _serviceUrl: URL;
    private readonly _clientUrl: URL;

    private readonly _serviceUrlString: string;
    private readonly _clientUrlString: string;

    public get appId(): string {
        return this._appId;
    }

    public get serviceUrl(): string {
        return this._serviceUrlString;
    }

    public get clientUrl(): string {
        return this._clientUrlString;
    }

    constructor(currentUrl: URL, serviceUrl: URL | undefined) {
        this._clientUrl = UrlUtils.stripFilePart(currentUrl);
        this._serviceUrl = serviceUrl || this._guessServiceUrl();

        // url bez lomítka na konci
        this._serviceUrlString = this._serviceUrl.href.endsWith("/") ? this._serviceUrl.href.substr(0, this._serviceUrl.href.length - 1) : this._serviceUrl.href;
        this._clientUrlString = this._clientUrl.href.endsWith("/") ? this._clientUrl.href.substr(0, this._clientUrl.href.length - 1) : this._clientUrl.href;

        this._appId = this._computeAppId(this._clientUrl);
    }

    private _computeAppId(clientUrl: URL): string {
        return (clientUrl.host + clientUrl.pathname).replace(/\W/g, "");
    }

    private _guessServiceUrl(): URL {
        // defaultně se počítá s tím, že služba bude umístěna o jednu úroveň výše než klient
        return new URL("..", this._clientUrl);
    }
}
